import React from 'react';
import PropTypes from 'prop-types';
import { Cloudinary, Actions } from '@cloudinary/url-gen';
import {
  AdvancedImage,
  AdvancedVideo,
  lazyload, responsive, // plugins
} from '@cloudinary/react';

const MultimediaImageVideoItem = ({ cloudinaryCloudName, mediaProperties }) => {
  const cloudinary = new Cloudinary({ cloud: { cloudName: cloudinaryCloudName } });
  const getDPR = () => window.devicePixelRatio ?? 1;
  const asset = mediaProperties.mediaType === 'image'
    ? cloudinary.image(mediaProperties.publicId).delivery(Actions.Delivery.dpr(getDPR()))
    : cloudinary.video(mediaProperties.publicId);
  const breakpoints = [400, 800, 1200, 1600];
  return (
    <>
      <div className="multimedia-add-ons__wrapper__item">
        {
          mediaProperties.mediaType === 'image'
            ? <AdvancedImage cldImg={asset} plugins={[lazyload(), responsive(breakpoints)]} />
            : <AdvancedVideo cldVid={asset} plugins={[lazyload()]} controls />
        }
      </div>
      <div className="multimedia-add-ons__wrapper__caption">
        { mediaProperties.caption ?? mediaProperties.caption}
      </div>
    </>
  );
};
MultimediaImageVideoItem.propTypes = {
  mediaProperties: PropTypes.shape({
    publicId: PropTypes.string.isRequired,
    multimediaAddOnId: PropTypes.number.isRequired,
    fileName: PropTypes.string.isRequired,
    mediaType: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired,
  }).isRequired,
  cloudinaryCloudName: PropTypes.string.isRequired,
};

export default MultimediaImageVideoItem;
